import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UmssDialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { UmssDialogFooterComponent } from '../dialog-footer/dialog-footer.component';
import { UmssVerticalFieldComponent } from '../vertical-field/vertical-field.component';
import { UmssInputComponent } from '../input/input.component';
import { UmssTextareaComponent } from '../textarea/textarea.component';
import { ContractorCitationService } from '@umss/shared/data-access';
import { createUpdateContractorCitationForm } from '@umss/shared/utils';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'umss-new-citation-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    UmssDialogHeaderComponent,
    UmssDialogFooterComponent,
    UmssVerticalFieldComponent,
    UmssInputComponent,
    UmssTextareaComponent
  ],
  templateUrl: './new-citation-dialog.component.html',
  styleUrls: ['./new-citation-dialog.component.scss']
})
export class NewCitationDialogComponent {
  @Input() contractorId?: string;
  @Input() facilityId?: string;

  @Output() onClose = new EventEmitter<void>();
  @Output() onSaved = new EventEmitter<void>();

  private readonly citationService = inject(ContractorCitationService);
  private readonly toastService = inject(ToastService);

  form = createUpdateContractorCitationForm();

  loading = false;

  close(): void {
    this.form.reset();
    this.onClose.emit();
  }

  save(): void {
    if (!this.facilityId || this.form.invalid) return;

    const { title, issue, requiredStepOrTraining } = this.form.getRawValue();

    this.loading = true;

    this.citationService
      .create({
        facilityId: this.facilityId,
        contractorId: this.contractorId ?? '',
        title,
        issue,
        requiredStepOrTraining
      })
      .subscribe({
        next: () => {
          this.loading = false;
          this.form.reset();
          this.onSaved.emit();

          this.toastService.openToast({
            type: 'Success',
            title: 'Citation created successfully'
          });
        },
        error: (error) => {
          console.error('Error creating citation:', error);
          this.loading = false;

          this.toastService.openToast({
            type: 'Error',
            title: error?.error?.message || 'Failed to create citation'
          });
        }
      });
  }
}
